<template>
  <ul
    class="rounded-md grid list-none grid-cols-3"
    :class="{
      'bg-transparent': variation === 'standard',
      ['bg-surface-default-low px-8 pb-12 pt-16']: variation === 'contrasted',
    }"
  >
    <li class="flex flex-col items-center gap-4">
      <div
        class="rounded-md p-8"
        :class="{
          'bg-transparent': variation === 'standard',
          'bg-surface-brand-hi': variation === 'contrasted',
        }"
      >
        <IconBadge class="mood-blush" size="medium" />
      </div>

      <span class="text-static-default-hi body-2 text-center">
        {{ i18n(translations.badge) }}</span
      >
    </li>
    <li class="flex flex-col items-center gap-8">
      <div
        class="rounded-md p-8"
        :class="{
          'bg-transparent': variation === 'standard',
          'bg-surface-brand-hi': variation === 'contrasted',
        }"
      >
        <IconTruck class="mood-blush" size="medium" />
      </div>
      <span class="text-static-default-hi body-2 text-center">
        {{ i18n(translations.truck) }}
      </span>
    </li>
    <li class="flex flex-col items-center gap-8">
      <div
        class="rounded-md p-8"
        :class="{
          'bg-transparent': variation === 'standard',
          'bg-surface-brand-hi': variation === 'contrasted',
        }"
      >
        <IconMoney class="mood-blush" size="medium" />
      </div>
      <span class="text-static-default-hi body-2 text-center">
        {{ i18n(translations.money) }}
      </span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconBadge } from '@ds/icons/IconBadge'
import { IconMoney } from '@ds/icons/IconMoney'
import { IconTruck } from '@ds/icons/IconTruck'

import translations from './ReassuranceBanner.translations'

defineProps<{
  variation: 'standard' | 'contrasted'
}>()

const i18n = useI18n()
</script>
